import React, { useState, useEffect } from 'react';
import api from '../services/api';

const PRESET_COLORS = [
  '#185FA5', '#3B6D11', '#6B3FA0', '#A32D2D', '#854F0B',
  '#0D7377', '#C2185B', '#00695C', '#1565C0', '#4E342E',
];

function getToken() { return window.__cafeApiToken || localStorage.getItem('cafepos_token'); }
const authH = () => ({ Authorization: `Bearer ${getToken()}` });

export default function Stations() {
  const [stations, setStations] = useState([]);
  const [menu, setMenu]         = useState([]);
  const [saving, setSaving]     = useState(null);
  const [toast, setToast]       = useState('');
  const [modal, setModal]       = useState(null); // null | { mode: 'add' | 'edit', station? }
  const [delConfirm, setDelConfirm] = useState(null); // station to delete

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  async function load() {
    const [s, m] = await Promise.all([
      fetch('/api/kitchen/stations', { headers: authH() }).then(r => r.json()),
      api.getMenu(),
    ]);
    setStations(s);
    setMenu(m);
  }

  useEffect(() => { load(); }, []);

  function isAssigned(stationId, categoryId) {
    return stations.find(s => s.id === stationId)?.categories.some(c => c.id === categoryId);
  }

  async function toggleCategory(station, category) {
    const current = station.categories.map(c => c.id);
    const updated = current.includes(category.id)
      ? current.filter(id => id !== category.id)
      : [...current, category.id];

    setSaving(station.id);
    try {
      await fetch(`/api/kitchen/stations/${station.id}/categories`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authH() },
        body: JSON.stringify({ category_ids: updated }),
      });
      await load();
      showToast('Zapisano');
    } finally { setSaving(null); }
  }

  async function handleSave(form) {
    const isEdit = !!form.id;
    const url = isEdit ? `/api/kitchen/stations/${form.id}` : '/api/kitchen/stations';
    const method = isEdit ? 'PATCH' : 'POST';
    const r = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json', ...authH() },
      body: JSON.stringify({ name: form.name, slug: form.slug, color: form.color, sound_enabled: form.sound_enabled }),
    });
    const data = await r.json();
    if (!r.ok) { showToast('Błąd: ' + data.error); return; }
    setModal(null);
    await load();
    showToast(isEdit ? 'Zaktualizowano stanowisko' : 'Dodano stanowisko');
  }

  async function handleDelete(station) {
    const r = await fetch(`/api/kitchen/stations/${station.id}`, {
      method: 'DELETE', headers: authH(),
    });
    const data = await r.json();
    if (!r.ok) { showToast('Błąd: ' + data.error); return; }
    setDelConfirm(null);
    await load();
    showToast(`Usunięto stanowisko „${station.name}"`);
  }

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ fontSize: 18, fontWeight: 500 }}>Stanowiska kuchenne</h2>
        <button className="btn-primary" style={{ width: 'auto', padding: '9px 16px' }}
          onClick={() => setModal({ mode: 'add' })}>
          + Dodaj stanowisko
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
        {stations.map(station => (
          <div key={station.id} style={{ background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{
              background: (station.color || '#185FA5') + '18',
              borderBottom: '0.5px solid var(--border)',
              padding: '12px 16px',
              display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <div style={{ width: 12, height: 12, borderRadius: '50%', background: station.color || '#185FA5', flexShrink: 0 }} />
              <span style={{ fontWeight: 500, fontSize: 15, flex: 1 }}>{station.name}</span>
              <span style={{ fontSize: 11, color: 'var(--text-muted)', marginRight: 4 }}>/{station.slug}</span>
              {saving === station.id && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Zapisuję...</span>}
              <button onClick={() => setModal({ mode: 'edit', station })}
                style={{ background: 'none', border: 'none', fontSize: 14, cursor: 'pointer', color: 'var(--text-muted)', padding: '2px 4px' }}>✏️</button>
              <button onClick={() => setDelConfirm(station)}
                style={{ background: 'none', border: 'none', fontSize: 14, cursor: 'pointer', color: 'var(--red,#dc2626)', padding: '2px 4px' }}>🗑</button>
            </div>
            <div style={{ padding: '8px 16px' }}>
              {menu.length === 0 && <div style={{ fontSize: 13, color: 'var(--text-muted)', padding: '8px 0' }}>Ładowanie kategorii...</div>}
              {menu.map(cat => (
                <label key={cat.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 0', cursor: 'pointer', borderBottom: '0.5px solid var(--border)' }}>
                  <input type="checkbox"
                    checked={!!isAssigned(station.id, cat.id)}
                    onChange={() => toggleCategory(station, cat)}
                    style={{ width: 15, height: 15, cursor: 'pointer' }} />
                  <span style={{ fontSize: 14, flex: 1 }}>{cat.name}</span>
                  <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{cat.items?.length || 0} poz.</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <StationModal
          station={modal.station}
          onSave={handleSave}
          onClose={() => setModal(null)}
        />
      )}

      {delConfirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}>
          <div style={{ background: 'var(--surface)', borderRadius: 12, padding: 24, width: 340, maxWidth: '90vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Usuń stanowisko</h3>
            <p style={{ fontSize: 14, color: 'var(--text-muted)', marginBottom: 20 }}>
              Czy na pewno chcesz usunąć stanowisko <strong>„{delConfirm.name}"</strong>?
              Przypisania kategorii do tego stanowiska zostaną usunięte.
            </p>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setDelConfirm(null)}
                style={{ flex: 1, padding: '11px', border: '0.5px solid var(--border)', borderRadius: 8, background: 'none', cursor: 'pointer', fontSize: 14 }}>
                Anuluj
              </button>
              <button onClick={() => handleDelete(delConfirm)}
                style={{ flex: 1, padding: '11px', border: 'none', borderRadius: 8, background: '#dc2626', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                Usuń
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <div style={{ position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)', background: '#1a1a1a', color: '#fff', padding: '10px 20px', borderRadius: 8, fontSize: 13, zIndex: 999 }}>
          {toast}
        </div>
      )}
    </div>
  );
}

function StationModal({ station, onSave, onClose }) {
  const isEdit = !!station;
  const [form, setForm] = useState({
    name:  station?.name  || '',
    slug:  station?.slug  || '',
    color: station?.color || '#185FA5',
    sound_enabled: station?.sound_enabled === undefined ? true : !!station.sound_enabled,
  });
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  function autoSlug(name) {
    return name.toLowerCase()
      .replace(/ą/g,'a').replace(/ć/g,'c').replace(/ę/g,'e').replace(/ł/g,'l')
      .replace(/ń/g,'n').replace(/ó/g,'o').replace(/ś/g,'s').replace(/ź/g,'z').replace(/ż/g,'z')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  async function handleSubmit() {
    setSaving(true);
    await onSave({ id: station?.id, ...form });
    setSaving(false);
  }

  const valid = form.name.trim() && form.slug.trim() && /^[a-z0-9_-]+$/.test(form.slug);

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 300 }}>
      <div style={{ background: 'var(--surface)', borderRadius: 12, padding: 24, width: 380, maxWidth: '90vw' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600 }}>{isEdit ? 'Edytuj stanowisko' : 'Nowe stanowisko'}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-muted)' }}>×</button>
        </div>

        <div className="field">
          <label>Nazwa</label>
          <input value={form.name} onChange={e => {
            const v = e.target.value;
            set('name', v);
            if (!isEdit) set('slug', autoSlug(v));
          }} placeholder="np. Bar kawowy" />
        </div>

        <div className="field">
          <label>Slug <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 400 }}>(unikalny identyfikator, małe litery)</span></label>
          <input value={form.slug} onChange={e => set('slug', e.target.value.toLowerCase())}
            placeholder="np. bar-kawowy" />
          {form.slug && !/^[a-z0-9_-]+$/.test(form.slug) && (
            <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4 }}>Tylko małe litery, cyfry, myślniki i podkreślenia</div>
          )}
        </div>

        <div className="field">
          <label>Kolor</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
            {PRESET_COLORS.map(c => (
              <button key={c} onClick={() => set('color', c)}
                style={{
                  width: 28, height: 28, borderRadius: '50%', background: c, border: 'none',
                  cursor: 'pointer', outline: form.color === c ? `3px solid ${c}` : 'none',
                  outlineOffset: 2, flexShrink: 0,
                }} />
            ))}
            <input type="color" value={form.color} onChange={e => set('color', e.target.value)}
              style={{ width: 36, height: 28, borderRadius: 6, border: '0.5px solid var(--border)', cursor: 'pointer', padding: 2 }} />
            <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{form.color}</span>
          </div>
          <div style={{ marginTop: 10, padding: '8px 12px', borderRadius: 8, background: form.color + '18', border: `1px solid ${form.color}40`, display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 12, height: 12, borderRadius: '50%', background: form.color }} />
            <span style={{ fontSize: 13, fontWeight: 500 }}>{form.name || 'Podgląd'}</span>
          </div>
        </div>

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 0', cursor: 'pointer', fontSize: 14 }}>
          <input type="checkbox" checked={form.sound_enabled} onChange={e => set('sound_enabled', e.target.checked)} />
          🔔 Dźwięk przy nowym zamówieniu na tym stanowisku
        </label>

        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          <button onClick={onClose}
            style={{ flex: 1, padding: '11px', border: '0.5px solid var(--border)', borderRadius: 8, background: 'none', cursor: 'pointer', fontSize: 14, color: 'var(--text-muted)' }}>
            Anuluj
          </button>
          <button onClick={handleSubmit} disabled={!valid || saving}
            style={{ flex: 2, padding: '11px', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600,
              background: valid ? 'var(--blue)' : 'var(--border)',
              color: valid ? '#fff' : 'var(--text-muted)',
              cursor: valid ? 'pointer' : 'not-allowed' }}>
            {saving ? 'Zapisuję...' : (isEdit ? 'Zapisz zmiany' : 'Dodaj stanowisko')}
          </button>
        </div>
      </div>
    </div>
  );
}
